<script>
export default {
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    tableHeaders() {
      const th = this.headers.slice(0)
      return th.push({ text: 'Actions' })
    },
  },

  methods: {
    deleteItem(item) {
      this.deleteDialog = true
      this.deleteItem = item
    },
    closeDialog() {
      this.deleteDialog = false
      this.deleteItem = {}
    },
    onDelete() {
      this.$emit('delete', this.deleteItem)
      this.closeDialog()
    },
  },
}
</script>

<template>
  <div>
    <VDataTable :headers="tableHeaders" :items="items" hide-actions>
      <template slot="items" slot-scope="props">
        <td v-for="header in headers" :key="`${header.text}-${index}`">
          {{ props.item[header.value] }}
        </td>
        <td>
          <!-- Edit Icon -->
          <VIcon small class="mr-2" @click="$emit('edit', props.item)">
            edit
          </VIcon>
          <!-- End of Edit Icon -->

          <!-- Delete Icon -->
          <VIcon small @click="deleteItem(props.item)">
            delete
          </VIcon>
          <!-- End of Delete Icon -->
        </td>
      </template>
    </VDataTable>

    <!-- Edit Dialog -->
    <VDialog v-model="deleteDialog" max-width="290px" persistent>
      <VCard>
        <VCardTitle class="headline">Delete entry</VCardTitle>

        <VCardText>Are you sure want to delete this entry?</VCardText>

        <VCardActions>
          <VSpacer />
          <VBtn color="grey" flat @click="closeDialog">
            Cancel
          </VBtn>

          <VBtn :color="color" flat @click="onDelete">
            Delete
          </VBtn>
        </VCardActions>
      </VCard>
    </VDialog>
    <!-- End of Edit Dialog -->
  </div>
</template>
